import Post from './Post'

const PostList = ({posts, categories, updateFilter}) => {
    return (
        <div className="post-list posts-wrapper">
            {posts.map((post) => {

                const post_categories = categories.map((category) => {
                    if (post.categories.includes(category.id)) {
                        return category
                    }
                })

                return (
                    <Post
                        title={post.title.rendered}
                        imageURL={post.featured_img_url}
                        date={post.date_formatted}
                        link={post.link}
                        excerpt={post.excerpt.rendered}
                        categories={post_categories}
                        author={post.author_name}
                        updateFilter={updateFilter}
                        portrait={post.author_portrait}
                        author_url ={post.author_url}
                    />
                )
            })}
        </div>
    )
}

export default PostList